import React from 'react';
//import Header from '../components/Header';
//import CustomFooter from '../components/Footer';

const TermsAndConditions = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            {/*<Header />*/}
            <div className="flex-grow container mx-auto p-4">
                <h1 className="mt-5 text-2xl font-bold">Terms and Conditions</h1>
                <div className="terms mt-5">
                    <p>
                        Welcome to the Nigerian Competitive Programming Community (NCP-Community). By accessing or using NCP-Community, you agree to
                        be bound by the following terms and conditions:
                    </p>
                    <ol className="list-decimal list-inside">
                        <li>This community is dedicated to promoting and fostering a culture of competitive programming.</li>
                        <li>All members must adhere to ethical and fair play standards when
                            interacting with other members within the community.</li>
                        <li>NCP-Community Admins reserves the right to moderate and take necessary actions to maintain a positive and inclusive
                            environment.</li>
                        <li>Members are responsible for their conduct and interactions within the community.</li>
                        <li>NCP-Community may update these terms and conditions from time to time. It is your responsibility to review
                            and comply with the latest terms.</li>
                        <li>Any violation of these terms may result in suspension or termination of membership.</li>
                    </ol>
                </div>
            </div>
            {/*<CustomFooter />*/}
        </div>
    );
};

export default TermsAndConditions;